module.exports = __webpack_public_path__ + "static/media/navidad6.13c87471.webp";